<mat-menu #appMenu="matMenu" xPosition="before">
  @for (button of buttons; track button) {
    <div>
      @if (!isHidden(button)) {
        <button mat-menu-item (click)="button.func(button.data)">
          <mat-label>{{ button.name | translate }}</mat-label>
        </button>
      }
    </div>
  }
</mat-menu>
<button mat-icon-button [matMenuTriggerFor]="appMenu" (menuOpened)="toggleEventCompleted.emit(true)" (menuClosed)="toggleEventCompleted.emit(true)">
  <mat-icon style="color: black">more_horiz</mat-icon>
</button>
